<template>
  <div class="mw-panel mw-view__imbedded">
    <div class="mw-toolbar" v-if="menuItems.length>1">
      <el-menu :default-active="defaultKey" mode="horizontal" @select="_handleSelect">
        <el-menu-item :index="v.id" :key="v.id" v-for="v in menuItems" v-text="v.name"><span
          class="badge badge-danger"></span></el-menu-item>
      </el-menu>
    </div>
    <div :class="{'mw-toolbar__body':menuItems.length>1,'mw-panel':(menuItems.length==0 ||menuItems.length==1)}">
      <div class="mw-page-view__config mw-panel"></div>
    </div>
  </div>
</template>
<script>
  import index from './index'
  export default index;
</script>



// WEBPACK FOOTER //
// src/common/components/extend/view/index.vue